import { cn } from '@/lib/utils';
import { BillTotalsVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import MoneyAmountList from '@/features/dashboard/bookingChanges/components/primitives/MoneyAmountList.tsx';
import ParticipantTotalsRow from './ParticipantTotalsRow';
import {
  getParticipantTotal,
  getParticipantTotalLabel,
} from './participantTotals';

interface ParticipantTotalsSummaryProps
  extends React.HTMLAttributes<HTMLDivElement> {
  totals: BillTotalsVm;
  isEditing: boolean;
}

/**
 * Rachunek uczestnika zwinięty do kwoty. W szkicu nad sumą stają dwa wiersze
 * rozbicia — stan sprzed zmiany i delta — żeby dało się ją odczytać jako wynik
 * działania, a nie kolejną liczbę.
 */
const ParticipantTotalsSummary = ({
  totals,
  isEditing,
  className,
  ...props
}: ParticipantTotalsSummaryProps) => {
  const total = getParticipantTotal(totals, isEditing);

  return (
    <div className={cn('flex flex-col gap-3', className)} {...props}>
      {isEditing && (
        <>
          <ParticipantTotalsRow
            label="Rachunek przed zmianą"
            value={<MoneyAmountList values={totals.before} />}
          />
          <ParticipantTotalsRow
            tone="strong"
            label="Zmiany w szkicu"
            value={<MoneyAmountList values={totals.delta} variant="signed" />}
          />
        </>
      )}

      <ParticipantTotalsRow
        className="border-t border-neutral-200 pt-3"
        tone="total"
        label={getParticipantTotalLabel(isEditing)}
        value={<MoneyAmountList values={total} />}
      />
    </div>
  );
};

export default ParticipantTotalsSummary;
